import { render, staticRenderFns } from "./detalleCredito.vue?vue&type=template&id=93fcfc28&scoped=true&"
import script from "./detalleCredito.vue?vue&type=script&lang=js&"
export * from "./detalleCredito.vue?vue&type=script&lang=js&"
import style0 from "./detalleCredito.vue?vue&type=style&index=0&id=93fcfc28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fcfc28",
  null
  
)

export default component.exports